import React, { useState, useEffect } from 'react';
import './HeroSection.css';
import mainImage from '../assets/img/main16.png';
import abcnetLogo from '../assets/img/abcnet.png';

const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const setRandomTranslateValues = () => ({
    translateX: getRandomInt(-500, 500) + 'px',
    translateY: getRandomInt(-500, 500) + 'px',
});

const Circle = ({ className }) => {
    const [position, setPosition] = useState(setRandomTranslateValues());

    useEffect(() => {
        const interval = setInterval(() => {
            setPosition(setRandomTranslateValues());
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div
            className={className}
            style={{
                transform: `translate(${position.translateX}, ${position.translateY})`,
            }}
        ></div>
    );
};

const HeroSection = () => {
    const [isMobile, setIsMobile] = useState(false);

    // Rozpoznání mobilního zařízení (při mountu a při změně velikosti okna)
    useEffect(() => {
        const checkDevice = () => setIsMobile(window.innerWidth <= 768);
        checkDevice();
        window.addEventListener('resize', checkDevice);
        return () => window.removeEventListener('resize', checkDevice);
    }, []);

    return (
        <div className="container2" style={{ background: '#000000' }}>
            {isMobile ? (
                // 📱 Mobilní verze – jednoduché logo
                <div className="heroMobileContainer">
                    <img alt="ABC NET logo" src={abcnetLogo} className="heroMobileLogo" />
                    <Circle className="circle" />
                    <Circle className="circle2" />
                    <Circle className="circle3" />
                </div>
            ) : (
                // 💻 Desktop verze – původní animovaný hero
                <>
                    <img alt="main logo" src={mainImage} className="mainLogo" />
                    <Circle className="circle" />
                    <Circle className="circle2" />
                    <Circle className="circle3" />
                </>
            )}
        </div>
    );
};

export default HeroSection;
